import React from "react";

export function NoMatch() {
  return <h1>404 page</h1>;
}
